import { render, staticRenderFns } from "./Dict.vue?vue&type=template&id=d5cd9ac0&"
import script from "./Dict.vue?vue&type=script&lang=js&"
export * from "./Dict.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports